(() => {
  const gallerySelector = '.js-product-gallery';
  const cellSelector = '.carousel-main .carousel-cell';
  const states = new WeakMap();
  const galleries = new Set();

  function cellsFor(gallery) {
    return Array.from(gallery.querySelectorAll(cellSelector));
  }

  function sync(gallery) {
    const state = states.get(gallery);
    if (!state) return;
    const cells = cellsFor(gallery);
    let activeCell = null;

    if (gallery.hasAttribute('data-static-gallery')) {
      activeCell = gallery.querySelector('.carousel-main .carousel-cell.is-selected') || cells[0] || null;
    } else if (state.ratios) {
      let bestRatio = 0.55;
      for (const [cell, ratio] of state.ratios) {
        if (ratio >= bestRatio) {
          bestRatio = ratio;
          activeCell = cell;
        }
      }
    }

    for (const cell of cells) {
      const video = cell.querySelector('video');
      if (!video) continue;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');

      if (cell === activeCell && document.visibilityState === 'visible') {
        if (video.paused) {
          const result = video.play();
          if (result && typeof result.catch === 'function') result.catch(() => {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    }
  }

  function init(gallery) {
    if (states.has(gallery)) return;
    const state = {};
    states.set(gallery, state);
    galleries.add(gallery);

    if (gallery.hasAttribute('data-static-gallery')) {
      const slider = gallery.querySelector('.carousel-main');
      if (slider) {
        state.classObserver = new MutationObserver(() => sync(gallery));
        state.classObserver.observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
        slider.addEventListener('change', () => sync(gallery));
      }
      sync(gallery);
      return;
    }

    state.ratios = new Map();
    if ('IntersectionObserver' in window) {
      state.intersectionObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          state.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
        }
        sync(gallery);
      }, { threshold: [0, 0.55, 0.75, 1] });
      for (const cell of cellsFor(gallery)) state.intersectionObserver.observe(cell);
    } else {
      sync(gallery);
    }
  }

  function scan(root) {
    if (root.nodeType === 1 && root.matches(gallerySelector)) init(root);
    if (root.querySelectorAll) root.querySelectorAll(gallerySelector).forEach(init);
  }

  function boot() {
    scan(document);
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) scan(node);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('visibilitychange', () => {
    for (const gallery of galleries) sync(gallery);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();